export default "/kiban/_next/static/images/scrolltop-eb499a49f4e255af102cc20ddba8963a.png";